// extracted by mini-css-extract-plugin
export default {"removeButton":"RemoveLineItemButton_removeButton__frtjJ"};